module.exports = __webpack_public_path__ + "img/20.b245d18b.jpg";